import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import helpIcon from "../../assets/images/icon_card/help.svg";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import CustomApp from "../../core/models/customApp";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import { toast } from "react-toastify";
const PickupStudentMobile = (props: any) => {
  const user: User = useAppSelector((state) => state.user.user);
  const [company, setCompany] = useState<any>({});
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const token: String = useAppSelector((state) => state.token.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isScanOpen, setIsScanOpen] = useState(false);
  const { t } = useTranslation();
  const [status, setStatus] = useState<any>({
    waiting: "Menunggu Jemputan",
    finished: "Selesai Dijemput",
    not_listed: "Belum Masuk Antrian",
  });

  const env = Config.BaseUrlDev;

  // useEffect(() => {
  //   console.log(props.data);

  //   setCompany(JSON.parse(localStorage.getItem("company") || ""));
  //   if (user == undefined) {
  //     navigate("/login", { replace: true });
  //   } else {
  //   }
  // }, []);

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) {
    }
  }, [location.pathname.split("/")[2]]);

  function closeScanModal() {
    setIsScanOpen(false);
  }

  const handleRefresh = async () => {};
  const gotoDetail = (id: any) => {
    if (id) return props.toDetailPage(id);
    toast.warning(t("PICKUPSTUDENT.notListed"));
  };

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        {/* <div className="bg-white px-8 pt-8 pb-3  sticky top-0 z-50">
          <TabsMobile
            name={`${t("PICKUPSTUDENT.title")}`}
            backUrl={"home"}
          ></TabsMobile>
        </div> */}
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-[calc(100vh-136px)]  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-5 w-full h-full">
              <div className="flex flex-col justify-start h-full w-full">
                <div className="flex flex-col gap-3 justify-center w-full">
                  {props.data.map((el: any) => (
                    <div
                      onClick={() => gotoDetail(el.pickupId)}
                      className="flex gap-2 w-full h-24 justify-start px-10 items-center bg-white rounded-xl cursor-pointer"
                    >
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 40.0001C31.0457 40.0001 40 31.048 40 20.005C40 8.96209 31.0457 0.0100098 20 0.0100098C8.9543 0.0100098 0 8.96209 0 20.005C0 31.048 8.9543 40.0001 20 40.0001Z"
                          fill="#EAD432"
                        />
                        <mask
                          id="mask0_797_11833"
                          style={{ maskType: "luminance" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="40"
                          height="40"
                        >
                          <path
                            d="M20 39.9901C31.0457 39.9901 40 31.038 40 19.995C40 8.95208 31.0457 0 20 0C8.95431 0 0 8.95208 0 19.995C0 31.038 8.95431 39.9901 20 39.9901Z"
                            fill="white"
                          />
                        </mask>
                        <g mask="url(#mask0_797_11833)">
                          <path
                            d="M26.5872 27.6235L35.2211 31.537L36.8207 49.9229H8.47498V31.547L18.7879 27.4248L26.5872 27.6235Z"
                            fill="#25A4C4"
                          />
                          <path
                            d="M19.8907 26.7195C19.1553 26.7246 18.4511 27.0176 17.9292 27.5357C17.4073 28.0537 17.1093 28.7556 17.0989 29.4908V29.5603C17.1358 30.9019 17.3257 32.235 17.6651 33.5335L21.997 30.9907L24.7392 33.3448C25.4208 33.0619 26.0197 32.6112 26.48 32.0346C26.9404 31.458 27.2473 30.7742 27.3721 30.047V29.9676C27.4438 29.5612 27.4249 29.144 27.3166 28.7457C27.2084 28.3475 27.0134 27.9781 26.7457 27.664C26.478 27.3499 26.1442 27.0987 25.7681 26.9286C25.392 26.7584 24.983 26.6735 24.5703 26.6798L19.8907 26.7195Z"
                            fill="white"
                          />
                          <path
                            d="M20.934 29.461C20.5104 29.4623 20.0907 29.3801 19.699 29.2189C19.3073 29.0578 18.9513 28.8209 18.6513 28.5219C18.3513 28.223 18.1133 27.8677 17.9509 27.4766C17.7885 27.0855 17.705 26.6662 17.705 26.2428V21.6438H24.153V26.213C24.157 26.6381 24.0766 27.0598 23.9166 27.4537C23.7566 27.8476 23.5201 28.2059 23.2208 28.5079C22.9215 28.8099 22.5652 29.0497 22.1727 29.2132C21.7802 29.3768 21.3592 29.4611 20.934 29.461Z"
                            fill="#E38073"
                          />
                          <path
                            d="M18.8376 28.4975C18.0158 28.5001 17.2016 28.3399 16.4421 28.0261C15.6826 27.7124 14.9929 27.2512 14.4127 26.6693C13.8325 26.0874 13.3734 25.3964 13.062 24.6361C12.7505 23.8758 12.5929 23.0613 12.5981 22.2397V13.3994H22.9211C23.1998 13.3994 23.4758 13.4545 23.7332 13.5614C23.9906 13.6684 24.2243 13.8251 24.421 14.0226C24.6176 14.2201 24.7733 14.4545 24.879 14.7124C24.9848 14.9702 25.0386 15.2464 25.0373 15.5251V22.2397C25.0425 23.058 24.8861 23.8692 24.5772 24.6269C24.2682 25.3846 23.8127 26.0739 23.2368 26.6552C22.6608 27.2366 21.9757 27.6986 21.2208 28.0147C20.4659 28.3308 19.6561 28.4949 18.8376 28.4975Z"
                            fill="#FFA69C"
                          />
                          <path
                            d="M25.5738 23.0344C26.6219 23.0344 27.4715 22.185 27.4715 21.1372C27.4715 20.0894 26.6219 19.24 25.5738 19.24C24.5258 19.24 23.6761 20.0894 23.6761 21.1372C23.6761 22.185 24.5258 23.0344 25.5738 23.0344Z"
                            fill="#FFA69C"
                          />
                          <path
                            d="M21.4704 30.8317C21.5128 30.8422 21.5571 30.8422 21.5995 30.8317C21.6267 30.8282 21.6529 30.8191 21.6765 30.8049C21.7 30.7908 21.7203 30.7719 21.7362 30.7496C21.752 30.7272 21.7631 30.7017 21.7687 30.6748C21.7742 30.648 21.7741 30.6202 21.7684 30.5934C21.7564 30.5389 21.724 30.491 21.6778 30.4596C21.6317 30.4282 21.5752 30.4157 21.52 30.4246C21.4524 30.4473 21.3792 30.4473 21.3115 30.4246C21.2587 30.4082 21.2017 30.4125 21.152 30.4364C21.1022 30.4604 21.0634 30.5023 21.0433 30.5537C21.0298 30.6076 21.0365 30.6646 21.0621 30.714C21.0877 30.7634 21.1305 30.8017 21.1823 30.8218C21.2771 30.8418 21.3745 30.8451 21.4704 30.8317Z"
                            fill="black"
                          />
                          <path
                            d="M25.0571 19.389L24.9378 20.5214L24.3318 20.3128L24.4212 17.0945L23.7854 16.727C22.9578 16.2533 22.2426 15.606 21.689 14.8298L21.1524 14.065L13.9195 13.767L12.5981 16.3297C12.5981 16.3297 10.0645 11.1447 13.1644 10.1911C16.2642 9.23756 22.4937 7.59863 25.2757 10.5785C25.2757 10.5785 28.614 11.7407 29.071 14.3133C29.528 16.8859 26.9845 19.8758 26.9845 19.8758C26.7343 19.6326 26.4244 19.4595 26.0861 19.3741C25.7477 19.2886 25.3928 19.2938 25.0571 19.389Z"
                            fill="#231F20"
                          />
                          <path
                            d="M8.62395 31.3978C9.04735 31.455 9.44552 31.6323 9.77127 31.9086C10.097 32.185 10.3367 32.5489 10.462 32.9573C10.8779 34.2004 11.0003 35.5229 10.8197 36.8212C10.4123 39.662 8.70345 47.8269 8.70345 47.8269L1.74866 50.8068C1.74866 50.8068 3.58667 38.7085 5.30549 34.9141C6.63684 32.1726 7.36215 31.2588 8.62395 31.3978Z"
                            fill="#1F8BA6"
                          />
                          <path
                            d="M33.7208 31.3978C33.2969 31.4567 32.8983 31.6344 32.5713 31.9104C32.2442 32.1864 32.0021 32.5494 31.8729 32.9573C31.4662 34.2024 31.3473 35.5235 31.5251 36.8212C31.9324 39.662 33.6413 47.8269 33.6413 47.8269L40.5961 50.8068C40.5961 50.8068 38.768 38.7085 37.0492 34.9141C35.7079 32.1726 34.923 31.2588 33.7208 31.3978Z"
                            fill="#1F8BA6"
                          />
                        </g>
                      </svg>
                      <div className="flex flex-col gap-1">
                        <span className="text-base font-medium">{el.name}</span>
                        <span className="text-sm">{status[el.status]}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Transition appear show={isScanOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeScanModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      <img src={helpIcon} alt="" className="text-black mr-2" />
                      {/* <div>{t("DIGITALCARD.help")}</div> */}
                    </div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary mt-3 p-2"></div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default PickupStudentMobile;
